import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import StudentAccountingService from 'services/studentAccountingServices';

const initialState = {
  isLoading: false,
  activeList: [],
  newmonthList: [],
  pendingList: [],
  data: null
};

// Data murid aktif (semua)
export const getActiveList = createAsyncThunk(
  'accountingStudent/activeList',
  async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
    try {
      const response = await StudentAccountingService.getActiveList(page, perPage, sort, orderBy, search);
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getActiveDetail = createAsyncThunk('accountingStudent/activeDetail', async (id, thunkAPI) => {
  try {
    const response = await StudentAccountingService.getActiveDetail(id);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// Data murid bulan ini (yang baru diaktifkan)
export const getNewmonthList = createAsyncThunk(
  'accountingStudent/newmonthList',
  async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
    try {
      const response = await StudentAccountingService.getNewmonthList(page, perPage, sort, orderBy, search);
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getNewmonthDetail = createAsyncThunk('accountingStudent/newmonthDetail', async (id, thunkAPI) => {
  try {
    const response = await StudentAccountingService.getNewmonthDetail(id);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// Data murid pending
export const getPendingList = createAsyncThunk(
  'accountingStudent/pendingList',
  async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
    try {
      const response = await StudentAccountingService.getPendingList(page, perPage, sort, orderBy, search);
      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPendingDetail = createAsyncThunk('accountingStudent/pendingDetail', async (id, thunkAPI) => {
  try {
    const response = await StudentAccountingService.getPendingDetail(id);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const accountingStudentSlice = createSlice({
  name: 'accountingStudent',
  initialState,
  reducers: {
    clearData: (state) => {
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    // Active List
    builder.addCase(getActiveList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getActiveList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.activeList = action.payload;
    });
    builder.addCase(getActiveList.rejected, (state) => {
      state.isLoading = false;
    });

    // Active Detail
    builder.addCase(getActiveDetail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getActiveDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getActiveDetail.rejected, (state) => {
      state.isLoading = false;
    });

    // Newmonth List
    builder.addCase(getNewmonthList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getNewmonthList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.newmonthList = action.payload;
    });
    builder.addCase(getNewmonthList.rejected, (state) => {
      state.isLoading = false;
    });

    // Newmonth Detail
    builder.addCase(getNewmonthDetail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getNewmonthDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getNewmonthDetail.rejected, (state) => {
      state.isLoading = false;
    });

    // Pending List
    builder.addCase(getPendingList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPendingList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.pendingList = action.payload;
    });
    builder.addCase(getPendingList.rejected, (state) => {
      state.isLoading = false;
    });

    // Pending Detail
    builder.addCase(getPendingDetail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPendingDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getPendingDetail.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

export const { clearData } = accountingStudentSlice.actions;
export default accountingStudentSlice.reducer;

